import styled from "styled-components";

export const Slot = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 15px;
  max-width: 500px;
  border-bottom: 1px #c0c0c0 solid;
  align-items: center;
  cursor: pointer;

  h4 {
    font-size: 18px;
    margin: 0;
    margin-bottom: 4px;
  }
  span {
    color: #8a8a8a;
    font-weight: 700;
  }
  p {
    font-size: 40px;
    margin: 0;
  }
  /* The following styles will apply when hovering over the div */
  &:hover {
    scale: 1.01;
  }
`;

export const SeeMoreButton = styled.button`
  margin-top: 20px;
  display: flex;
  max-width: 500px;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  color: #0e336e;
  font-size: 18px;
  font-weight: 700;
  padding: 10px;
  border-radius: 8px;
  border: 2px solid #0e336e;
  &:hover {
    scale: 1.01;
  }
`;
